import React from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";

import Layout from "../layouts";
import DashboardLayout from "../layouts/DashboardLayout";

import globalRoutes from "./globalRoutes";
import dashboardRoutesLazy from "./dashboardRoutes";
import bookingRoutes from "./bookingRoutes";

const router = createBrowserRouter([
  {
    path: "/",

    element: <Layout />,

    children: [
      {
        path: "",
        children: globalRoutes,
      },
      {
        // change later - because url changed
        path: "booking",
        children: bookingRoutes,
      },
      {
        path: "dashboard",
        element: <DashboardLayout />,
        children: dashboardRoutesLazy,
      },
    ],
  },
  {
    path: "*",

    element: <Layout />,

    children: [
      {
        path: "*",
        element: <Navigate to="/not-found" replace />,
      },
    ],
  },
]);

export default router;
